import React from "react";
import {
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const RadarChartComponent = ({ chartData }) => {
  // Trasformiamo i dati per DX e SX
  const chartDataPlot = chartData.map((item) => {
    const { side, ...metrics } = item; // Ignora la proprietà 'side'

    const transformedData = {
      DX: [],
      SX: [],
    };
    // Separa i dati in DX e SX
    Object.keys(metrics).forEach((key) => {
      const metricName = key
        .replace("Anca Destra", "")
        .replace("Anca Sinistra", "")
        .replace(/\([^)]*\)\s*/g, ""); // Rimuovi la parte (DX) o (SX) dalla chiave
      if (key.includes("Anca Destra")) {
        transformedData.DX.push({ name: metricName, value: metrics[key] });
      } else if (key.includes("Anca Sinistra")) {
        transformedData.SX.push({ name: metricName, value: metrics[key] });
      }
    });

    return transformedData;
  });

  // Uniamo i dati di DX e SX in un unico array per ogni metrica
  const finalData = [];
  const dxData = chartDataPlot[0]?.DX || [];
  const sxData = chartDataPlot[1]?.SX || [];

  dxData.forEach((metric, index) => {
    finalData.push({
      metric: metric.name,
      DX: metric.value,
      SX: sxData[index]?.value || 0, // Aggiungi un fallback per i valori SX
    });
  });

  // Verifica che i dati siano corretti e non vuoti
  if (finalData.length === 0) {
    return <div>No data available</div>;
  }

  return (
    <>
      {/* Contenitore principale per grafico e tabella */}

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        {/* Grafico Radar */}
        <div style={{ flex: 1, minWidth: "50%", maxWidth: "50%" }}>
          <ResponsiveContainer width="100%" height={400}>
            <RadarChart data={finalData}>
              <PolarGrid stroke="#ccc" strokeWidth={0.5} />

              {/* PolarAngleAxis: Mostra le etichette per ogni metrica */}
              <PolarAngleAxis dataKey="metric" tick={{ fill: "#fff" }} />

              {/* Nascondi i numeri sugli assi */}
              <PolarRadiusAxis tick={false} />

              {/* Radar per il lato DX */}
              <Radar
                name="DX"
                dataKey="DX"
                stroke="#8884d8"
                strokeWidth={3}
                fill="#8884d8"
                fillOpacity={0.6}
              />

              {/* Radar per il lato SX */}
              <Radar
                name="SX"
                dataKey="SX"
                stroke="#82ca9d"
                strokeWidth={3}
                fill="#82ca9d"
                fillOpacity={0.6}
              />

              {/* Aggiungi la legenda */}
              <Legend />

              {/* Tooltip per vedere i valori reali con personalizzazione del testo e dello sfondo */}
              <Tooltip
                formatter={(value) => value.toFixed(1)}
                contentStyle={{
                  backgroundColor: "#fff",
                  borderColor: "#ddd",
                  color: "#000",
                }} // Sfondo bianco e testo nero
                itemStyle={{ color: "#000" }} // Colore del testo nero
              />
            </RadarChart>
          </ResponsiveContainer>
        </div>

        {/* Tabella con i valori reali per DX e SX */}
        <div
          style={{
            flex: 1,
            minWidth: "50%",
            maxWidth: "50%",
            paddingLeft: "0px",
          }}
        >
          <br></br>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th
                  style={{
                    borderBottom: "2px solid #ddd",
                    textAlign: "left",
                    padding: "15px",
                  }}
                >
                  Metrica
                </th>
                <th
                  style={{
                    borderBottom: "2px solid #ddd",
                    textAlign: "center",
                    padding: "8px",
                  }}
                >
                  DX
                </th>
                <th
                  style={{
                    borderBottom: "2px solid #ddd",
                    textAlign: "center",
                    padding: "8px",
                  }}
                >
                  SX
                </th>
                <th
                  style={{
                    borderBottom: "2px solid #ddd",
                    textAlign: "center",
                    padding: "8px",
                  }}
                >
                  Differenza
                </th>
                <th
                  style={{
                    borderBottom: "2px solid #ddd",
                    textAlign: "center",
                    padding: "8px",
                  }}
                >
                  {"Differenza (%)"}
                </th>
              </tr>
            </thead>
            <tbody>
              {finalData.map((item, index) => {
                // Calcoliamo la differenza tra DX e SX
                const difference = (item.DX - item.SX).toFixed(0);
                const difference_per = Math.abs(
                  100 - ((item.DX * 100) / item.SX).toFixed(0)
                );
                return (
                  <tr key={index}>
                    <td style={{ padding: "8px" }}>{item.metric}</td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      {item.DX}
                    </td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      {item.SX}
                    </td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      {difference}
                    </td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      {difference_per}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Scritta "Trend Analysis" sotto il grafico e la tabella */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
          marginTop: "40px",
        }}
      >
        <h1>Trend Analysis</h1>
      </div>
    </>
  );
};

export default RadarChartComponent;
